.overlay {
  position: fixed;
  inset: 0;
  z-index: calc(var(--z-popover) + 5);
  display: flex;
  flex-direction: column;
  background: var(--surface);
}

.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-block-end: 1px solid var(--border);
  background: var(--surface-raised);
  color: var(--text);
}

.spacer {
  flex: 1;
}

/* The page guard (`.popover-open iframe`) mutes frames behind an open popover; the visitor's frame
   is the page now, so it keeps the pointer: the friend's view is fully interactive. */
.overlay .frame {
  flex: 1;
  inline-size: 100%;
  border: 0;
  pointer-events: auto;
}
